/*
 * http 请求详细配置
 * 认证方式采用jwt
 *
 *
 * @请求拦截钩子
 * 1.全局请求设置带上cookie
 * 2.超时时间统一设置
 * 3.设置请求头
 *
 * @响应拦截钩子
 * 1.http状态码200
 *     1.code 0 代表请求成功
 *     2.code 403 代表登陆过期
 *     3.code
 * 2.http状态吗不为200
 *
 */
import axios from "axios"
import router from "../router"
import { BaseConfig } from "@/config.default"







const axiosInstance = axios.create({
    baseURL: BaseConfig.devUrl
}) //修复mock触发两次的问题

// axiosInstance.defaults.withCredentials = true //允许携带cookie
axiosInstance.defaults.timeout = BaseConfig.httpRequest.timeout //超时时间
if (process.env.NODE_ENV === "development") {
    axiosInstance.defaults.baseURL = BaseConfig.devUrl //
} else {
    axiosInstance.defaults.baseURL = BaseConfig.proUrl
}






/*eslint-disable*/

export default {
    install: function(Vue) {
        let timer = Date.now(); //统计接口用时
        let timer2 = Date.now(); //统计接口用时
        const allRequestList = []; //所有请求存放数组，用于取消某些特定请求
        let isExpireRequest = false;
        //===============================axiosInstance请求钩子==========================================//
        axiosInstance.interceptors.request.use(
            config => {
                timer = Date.now();
                config.cancelToken = new axios.CancelToken((c) => {
                    allRequestList.push(
                        {
                            url: config.url,
                            cancelFn: c
                        }
                    );
                });
                config.headers["x-access-token"] = localStorage.token;
                return config
            },
            err => {
                timer = Date.now();
                return Promise.reject(err)
            }
        )
        
        //===============================axiosInstance响应钩子=======================================//
        axiosInstance.interceptors.response.use(
            res => {
                let result = res.data;
                timer2 = Date.now() - timer;
                if (timer2 > BaseConfig.httpRequest.longRequestLimit) {
                    Vue.prototype.$langRequestWarning(res, timer2, router.currentRoute)
                }
                const headers = res.headers;
                const contentType = headers["content-type"].split(";")[0];
                if (!contentType.includes("application/json")) { //非常规数据
                    const contentDisposition = headers["content-disposition"] || "";
                    const disposition = contentDisposition.split(";")[0] || "";
                    const fileInfo = contentDisposition.split(";")[1] || "";
                    const fileName = fileInfo.split("=")[1];
                    return {
                        disposition,
                        fileName,
                        blob: res.data
                    };
                } else if (res.data.code != null) { //常规格式数据
                    const code = res.data.code;
                    switch (code) {
                        case 0: //正确请求
                            isExpireRequest = false; //重置过期登陆是否显示提示
                            
                            break;
                        case 4101: //token有错
                            router.replace("/login");
                            if (!isExpireRequest) {
                                Vue.prototype.$message.warning("暂无权限");
                                Vue.prototype.$httpFailCatch(res, timer2, router.currentRoute);
                                isExpireRequest = true;
                            }
                            return Promise.reject(new Error("暂无权限"))
                        case 4100: //token过期
                            router.replace("/login");
                            if (!isExpireRequest) {
                                Vue.prototype.$message.warning("登陆已过期");
                                Vue.prototype.$httpFailCatch(res, timer2, router.currentRoute);
                                isExpireRequest = true;
                            }
                            return Promise.reject(new Error("登陆已过期"))    
                        case 4002: //暂无权限
                            router.replace("/login");
                            if (!isExpireRequest) {
                                Vue.prototype.$message.warning("登陆已过期");
                                Vue.prototype.$httpFailCatch(res, timer2, router.currentRoute);
                                isExpireRequest = true;
                            }
                            return Promise.reject(new Error("登陆已过期"))
                        default:
                            Vue.prototype.$httpFailCatch(res, timer2, router.currentRoute)
                            Vue.prototype.$confirm(res.data.msg ? res.data.msg : "操作失败", "提示", {
                                confirmButtonText: "确定",
                                showCancelButton: false,
                                type: "warning"
                            });
                            return Promise.reject(new Error(res.data.msg))
                    }
                    return  result
                } else { //后台不规范的数据
                    Vue.prototype.$httpFailCatch(res, timer2, router.currentRoute);
                    Vue.prototype.$confirm(res.data.msg ? res.data.msg : "操作失败", "提示", {
                        confirmButtonText: "确定",
                        showCancelButton: false,
                        type: "warning"
                    });
                    const error = new Error("操作失败");
                    error.response = res;
                    return Promise.reject(error)
                }
            },
            err => {
                //=====================================取消错误不进行拦截====================================//
                if (err.constructor && err.constructor.name === "Cancel") {
                    return;
                }
                timer2 = Date.now() - timer;;
                Vue.prototype.$message.error("系统开小差了!")
                err.__time = timer2;
                err.__isHttpError = true;
                return Promise.reject(err)
            }
        )
        Vue.prototype.axios = axiosInstance
    },
    axios: axiosInstance
}
